module.exports = __webpack_public_path__ + "static/media/csharp-icon.98cf94f4.png";